import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import { createProvider } from "./vue-apollo";
import axios from "axios";
import VueAxios from "vue-axios";
import SetIcon from "./plugins/iconsetter";
import Loader from "./components/Loading.vue";
import SCFooter from "./components/Footer.vue";
import VueHead from "vue-head";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

Vue.component("vue-phone-number-input", VuePhoneNumberInput);
Vue.use(VueHead);
Vue.component("loader", Loader);
Vue.component("sc-footer", SCFooter);
Vue.use(VueAxios, axios);
Vue.use(SetIcon);
Vue.config.productionTip = true;
// eslint-disable-next-line
Vue.axios.defaults.baseURL = sc_config.apiUrl;
new Vue({
  vuetify,
  router,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount("#app");
